import { DevUrl, UatUrl, ProdUrl } from "./EnvUrl";

export const baseUrl = DevUrl;